import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';

const Layout = ({ children, breadcrumbItems = [] }) => {
  return (
    <div className="App">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-blue-700 focus:px-4 focus:py-2 focus:rounded focus:shadow"
      >
        Skip to main content
      </a>
      <Header />
      {breadcrumbItems.length > 0 && <Breadcrumb items={breadcrumbItems} />}
      <main id="main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
